import styled from 'styled-components';

import TabsCard from 'styled/components/TabsCard';

export default styled(TabsCard)`
  textarea {
    width: 100%;
    box-sizing: border-box;
    background-color: transparent;
    min-height: 100%;
    outline: 0;
    border: none;
    font-size: 12px;
    resize: none;
    color: ${(props) => props.theme.colors.text};
    line-height: 14px;
  }

  .content {
    height: 168px;
    display: flex;
    box-sizing: border-box;
  }
`;
